/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Scanner_Filter_ActiveInputs */

const en_portal_scanner_filter_active = /** @type {(inputs: Portal_Scanner_Filter_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter active.`)
};

const de_portal_scanner_filter_active = /** @type {(inputs: Portal_Scanner_Filter_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter active.`)
};

const fr_portal_scanner_filter_active = /** @type {(inputs: Portal_Scanner_Filter_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter active.`)
};

const es_portal_scanner_filter_active = /** @type {(inputs: Portal_Scanner_Filter_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter active.`)
};

const it_portal_scanner_filter_active = /** @type {(inputs: Portal_Scanner_Filter_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter active.`)
};

const nl_portal_scanner_filter_active = /** @type {(inputs: Portal_Scanner_Filter_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter active.`)
};

const pl_portal_scanner_filter_active = /** @type {(inputs: Portal_Scanner_Filter_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter active.`)
};

const fi_portal_scanner_filter_active = /** @type {(inputs: Portal_Scanner_Filter_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter active.`)
};

const da_portal_scanner_filter_active = /** @type {(inputs: Portal_Scanner_Filter_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter active.`)
};

const sv_portal_scanner_filter_active = /** @type {(inputs: Portal_Scanner_Filter_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter active.`)
};

/**
* | output |
* | --- |
* | "Filter active." |
*
* @param {Portal_Scanner_Filter_ActiveInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const portal_scanner_filter_active = /** @type {((inputs?: Portal_Scanner_Filter_ActiveInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Scanner_Filter_ActiveInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_portal_scanner_filter_active(inputs)
	if (locale === "fr") return fr_portal_scanner_filter_active(inputs)
	if (locale === "es") return es_portal_scanner_filter_active(inputs)
	if (locale === "it") return it_portal_scanner_filter_active(inputs)
	if (locale === "nl") return nl_portal_scanner_filter_active(inputs)
	if (locale === "pl") return pl_portal_scanner_filter_active(inputs)
	if (locale === "fi") return fi_portal_scanner_filter_active(inputs)
	if (locale === "da") return da_portal_scanner_filter_active(inputs)
	if (locale === "sv") return sv_portal_scanner_filter_active(inputs)
	return en_portal_scanner_filter_active(inputs)
});